import React from "react";
import { getArticleUrlWithoutSlug } from "./model";

interface Props {
  articleId: number
  className?: string
}

const SupportArticleLink = (props: React.PropsWithChildren<Props>) => {
  const { articleId, className, children } = props;


  return <a
    href={getArticleUrlWithoutSlug(articleId)}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
  >{children}</a>;
}

export default SupportArticleLink;